export default "__VITE_ASSET__ft_JirNl__"